export default __webpack_public_path__ + "static/blob1-07a23aa68b0148726120ff27dcac076d.svg";